$('#homepage-carousel').owlCarousel({
    loop: true,
    items: 1,
    dots: true,
    nav: false,
    autoplay: true,
    autoplayHoverPause: true,
    autoplaySpeed: 1500,
    autoplayTimeout: 6000,
    onChanged: function (event) {
        var position = event.item.index;

        $item = $(event.target).find('.owl-item').eq(position).children('[data-collection-title]');

        var title = $item.data('collection-title');
        var description = $item.data('collection-description');
        var url = $item.data('collection-url');
        var heading = $item.data('heading');
        var subheading = $item.data('subheading');
        var subheadingTop = $item.data('subheading-top');
        var headingColour = $item.data('heading-colour');
        var imgLink = $item.data('img-link');

        $('#carousel-title').html(heading);
        $('#carousel-subtitle').html(subheading);
        $('#carousel-subtitle-top').html(subheadingTop);
        $('#carousel-collection-title').html(title);
        $('#carousel-collection-description').html(description);
        $('#carousel-collection-link').attr('href', imgLink || url);

        if (headingColour == 'White') {
            $('#carousel-title').addClass('text-white');
            $('#carousel-subtitle').addClass('text-white');
            $('#carousel-subtitle-top').addClass('text-white');
        } else {
            $('#carousel-title').removeClass('text-white');
            $('#carousel-subtitle').removeClass('text-white');
            $('#carousel-subtitle-top').removeClass('text-white');
        }
    },
});

$('#hamper-carousel').owlCarousel({
    loop: false,
    autoplay: true,
    rewind: true,
    items: 1,
    dots: false,
    nav: true,
    onChanged: function (property) {
        $('#product-thumbnails a').removeClass('active');
        $('#product-thumbnails a[data-position=' + property.item.index + ']').addClass('active');
    },
});

$('#product-carousel').owlCarousel({
    loop: false,
    items: 1,
    dots: false,
    nav: true,
    onChanged: function (property) {
        $('#product-thumbnails a').removeClass('active');
        $('#product-thumbnails a[data-position=' + property.item.index + ']').addClass('active');
    },
});

$('#product-thumbnails').on('click', 'a', function (e) {
    e.preventDefault();
    var position = $(this).data('position');
    const target = $('#product-thumbnails').data('target');

    $(target).trigger('to.owl.carousel', position);
});
